import { Box } from '@chakra-ui/react';
import { Table as ReactTable } from '@tanstack/react-table';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { FacilitiesTableRow } from './facilitiesTableOptions';
import { IsolatedMultiSelect } from '~/packages/common-frontend/components/MultiSelect';

// Exports
type Props = { tableInstance: ReactTable<FacilitiesTableRow> };
export const FacilitiesColumnSelector = ({ tableInstance }: Props) => (
  <Box h="44px">
    <IsolatedMultiSelect
      options={tableInstance
        .getAllLeafColumns()
        // we do not want to list the sticky header column as an option to remove from the table
        // since this column is the anchor for the row
        .filter((column) => column.id !== 'creditFacilityName')
        .map((column) => ({
          label: commonUtils.toSentenceCase(
            // in the case where the column header (headerKey) and id (accessorKey) differ
            typeof column.columnDef.header === 'string'
              ? column.columnDef.header
              : column.id,
          ),
          value: column.id,
        }))}
      initialSelections={tableInstance
        .getAllLeafColumns()
        .filter((column) => column.getIsVisible())
        .map((column) => column.id)}
      onApplyOptions={(selectedOptions) => {
        tableInstance.setColumnVisibility((prevVisibilityState) => {
          const nextVisibilityState = { ...prevVisibilityState };
          Object.keys(nextVisibilityState).forEach((key) => {
            nextVisibilityState[key] = selectedOptions.includes(key);
          });
          return nextVisibilityState;
        });
      }}
      optionsHeader="Property"
      titleText="Show/Hide Columns"
      applyButtonText="Display selected columns"
      colorScheme="aurora"
      borderWidth="medium"
    />
  </Box>
);
